/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/*
* Hook into the mobile touch move event. This fix is specifically for
* iOS 10+ devices.
*
* If on a mobile device and a user is touching and moving
* the screen we check to see if it has the class 'disable-scroll'
* which is applied within the @onStart and @onEnd functions within
* the @DraggableUnitBlockContainerController, this then locks the
* screen within position so that the user can drag the block without
* the whole screen moving.
*/
$('body').on('touchmove', (e) => {
  if ($('body').hasClass('disable-scroll')) {
    e.preventDefault();
  }
});

angular.module('bulbApp.blockModule')
  .controller('DraggableUnitBlockContainerController', [
    '$scope', '$exceptionHandler', '$state', '$timeout', 'BulbAuthService',
    'BulbBlockViewSwitcherService', 'BulbDeletedUnitService', 'BulbUnitService', 'AUTH',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    DraggableUnitBlockContainerController]);

/**
 * AngularJS controller for a drag-and-drop reorder-able unit block container.
 */
function DraggableUnitBlockContainerController(
  $scope,
  $exceptionHandler,
  $state,
  $timeout,
  BulbAuthService,
  BulbBlockViewSwitcherService,
  BulbDeletedUnitService,
  BulbUnitService,
  AUTH,
) {
  this.isSingleAuthor = (this.compositeUnit.unitType !== 'GroupUnit'
    && this.compositeUnit.unitType !== 'AssignmentCompositeUnit'
    && !this.compositeUnit.groupCollection);

  this.isSingleType = (this.compositeUnit.unitType === 'CompositeUnit');

  this.isTemplate = this.compositeUnit.isTemplate;

  const { currentUser } = BulbAuthService;
  const childUnits = this.compositeUnit.children;

  this.showRecycleBin = this.compositeUnit.deleteAfterDays > 0 || BulbDeletedUnitService.isRecentlyDeletedSelected;

  this.readOnly = !currentUser.hasPermission(this.compositeUnit, AUTH.PERMISSIONS.UPDATE);
  $scope.readOnly = this.readOnly;

  $scope.viewSwitcherService = BulbBlockViewSwitcherService;

  $scope.showRecentlyDeletedButton = false;
  $scope.deletedCompositeUnit = undefined;
  /**
   * Whether the dragging is disabled on ctrl click.
   * @type {boolean}
   */
  let isElementDraggingDisabledOnCtrlClick = false;

  /**
   * Disable Drag for the draggable elements when ctrl is clicked on Macintosh.
   * @param event Keydown event
   */
  function disableDragOnCtrl(event) {
    if (event.key === 'Control' || event.key === 'Meta') {
      event.stopPropagation();
      event.preventDefault();
      document.querySelectorAll("[data-drag='true']").forEach((ele) => {
        ele.setAttribute('data-drag', 'false');
        ele.classList.add('ui-draggable-disabled');
        jQuery(ele).draggable('disable');
        isElementDraggingDisabledOnCtrlClick = true;
      });
    }
  }

  /**
   * Enable drag for the elements
   * @param event touchstart or mousedown event
   */
  function enableDragOnMouseDown(event) {
    if (isElementDraggingDisabledOnCtrlClick) {
      document.querySelectorAll("[data-drag='false']").forEach((ele) => {
        ele.setAttribute('data-drag', 'true');
        ele.classList.remove('ui-draggable-disabled');
        jQuery(ele).draggable().draggable('enable');
      });
    }
    isElementDraggingDisabledOnCtrlClick = false;
  }

  document.addEventListener('keydown', disableDragOnCtrl);

  document.addEventListener('mousedown', enableDragOnMouseDown);

  /**
   * Fetch deleted unit count.
   */
  if (BulbDeletedUnitService.authorAccountId
    && (currentUser.id === BulbDeletedUnitService.authorAccountId || BulbDeletedUnitService.isAdmin())) {
    BulbDeletedUnitService.getDeletedUnitCount().then((deletedUnitCount) => {
      $scope.noOfDeletedUnit = (deletedUnitCount) || 0;
      $scope.showRecentlyDeletedButton = BulbDeletedUnitService.isAdmin() || $scope.noOfDeletedUnit > 0;
    });
  }

  /**
   * Show breadcrumb for deleted collection.
   */
  $scope.showBreadcrumbForDeletedUnit = function showBreadcrumbForDeletedUnit(deletedUnit, unitType) {
    // Using $timeout to re-render breadcrumb
    if (unitType === 'DeletedUserUnit') {
      $state.reload();
    } else {
      $scope.deletedCompositeUnit = undefined;
      $timeout(() => {
        if (deletedUnit.unitType !== 'UserUnit') {
          $scope.deletedCompositeUnit = deletedUnit;
        }
      });
    }
  };

  // The archive feature needs the 'My Archive' collection to *always* be last.
  // This needs to only be done on the user's profile level.
  // The ArchiveFeature flag is only loaded on the initial login but could be externally enabled while the user
  // is logged in. So let's always move the archive units to the end.
  if (this.compositeUnit.unitType === 'UserUnit') {
    const index = this.compositeUnit.children.findIndex((unit) => unit.unitType === 'ArchiveCompositeUnit');
    if (index !== -1) {
      const archiveUnit = childUnits[index];
      childUnits.splice(index, 1);
      childUnits.push(archiveUnit);
    }
  }

  /**
   * Save the reorder of a child unit by posting the information to the server.
   * @param destinationMovedChildIndex The new index of the child unit.
   */
  this.saveReorder = function saveReorder(destinationMovedChildIndex) {
    if (!this.compositeUnit.children) {
      $exceptionHandler('Invalid argument', 'The unit does not have any children');
    }
    // Check if the indexes are valid
    const childrenLength = this.compositeUnit.children.length;
    if (destinationMovedChildIndex < 0 || destinationMovedChildIndex >= childrenLength) {
      $exceptionHandler('Invalid argument', 'The child index is not valid');
    }
    BulbUnitService.compositeUnitReorder(this.compositeUnit, destinationMovedChildIndex);
  };

  $scope.$on('$destroy', () => {
    document.removeEventListener('keydown', disableDragOnCtrl);

    document.removeEventListener('mousedown', enableDragOnMouseDown);
  });
}
